import { computed, ref } from 'vue';

const selectedVaultSageBot = ref(null);

const normalizeBot = bot => {
  if (!bot?.id) return null;

  return {
    id: bot.id,
    name: bot.name || '',
  };
};

export function useSelectedVaultSageBot() {
  const hasSelectedVaultSageBot = computed(
    () => !!selectedVaultSageBot.value?.id
  );
  const selectedVaultSageBotName = computed(
    () => selectedVaultSageBot.value?.name || ''
  );

  const setSelectedVaultSageBot = bot => {
    selectedVaultSageBot.value = normalizeBot(bot);
  };

  const clearSelectedVaultSageBot = () => {
    selectedVaultSageBot.value = null;
  };

  return {
    selectedVaultSageBot,
    selectedVaultSageBotName,
    hasSelectedVaultSageBot,
    setSelectedVaultSageBot,
    clearSelectedVaultSageBot,
  };
}
